import { useFinanceDeliveryPricesSelector } from "redux/reducers/deal";

export const useDeliveryPrice = accessoryId => {
  const financeDeliveryPrices = useFinanceDeliveryPricesSelector();

  if (!financeDeliveryPrices) {
    return null;
  }

  const matchingAccessory = financeDeliveryPrices.find(
    ({ key }) => key === accessoryId
  );

  return matchingAccessory?.increase.amountInclTax ?? null;
};
